import React, { useCallback, useRef, useState } from "react";
import { CSVLink } from "react-csv";
type Props = {
  headers: string[];
  title: string;
  getCsvData: () => Promise<any[]>;
};

const CsvBtn = ({ headers, title, getCsvData }: Props) => {
  const CsvRef = useRef<
    CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }
  >(null);
  const [data, setData] = useState<any[] | undefined>(undefined);
  const getCsv = useCallback(() => {
    getCsvData().then((res) => {
      if (res.length !== 0) {
        setData(res);
        setTimeout(() => {
          if (CsvRef.current) {
            CsvRef.current.link.click();
          }
        }, 500);
        setTimeout(() => {
          setData(undefined);
        }, 1000);
      }
    });
  }, [getCsvData, CsvRef]);

  return (
    <>
      <button className="export-excel" onClick={getCsv}>
        엑셀로 저장하기
      </button>
      {data ? (
        <CSVLink
          ref={CsvRef}
          style={{ display: "none" }}
          className="export-excel"
          headers={headers}
          filename={title}
          data={data}
        />
      ) : undefined}
    </>
  );
};

export default CsvBtn;
